import { createOnsiteInterviews } from './CreateOnsiteInterviews';
import { createOrPublishJobPosting } from './CreateOrPublishJobPosting';
import { getCandidates } from './GetCandidates';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getPaymentPlans } from './GetPaymentPlans';
import { getPostingDetails } from './GetPostingDetails';
import { removeShortlistCandidate } from './RemoveShortlistCandidate';
import { shortlistCandidate } from './ShortlistCandidate';
import { updateCandidateStatus } from './UpdateCandidateStatus';
import { updateJobPosting } from './UpdateJobPosting';

/**
 * Payment Plans Service
 * Provides business logic layer for payment plans operations
 */
export const PaymentPlansService = {
  getPaymentPlans,
};

/**
 * Permanent Jobs Service
 * Provides business logic layer for permanent jobs operations
 */
export const PermanentJobsService = {
  createOnsiteInterviews,
  createOrPublishJobPosting,
  getCandidates,
  getOnsiteInterviewList,
  getPostingDetails,
  removeShortlistCandidate,
  shortlistCandidate,
  updateCandidateStatus,
  updateJobPosting,
};
